import React, { useEffect, useState } from "react";
import { getPdfPageCount } from "../../utils/utils";

const JobFileItem = ({
    file,
    onDownload,
}) => {

    const formatOptions = (file) => {
        if (!file?.printOptions) return "";

        const o = file.printOptions;

        const result = [];

        // Paper size
        if (o.paperSize) result.push(o.paperSize);

        // Color
        if (o.color) {
            if (o.color === "Color") {
                result.push("Colour");
            } else if (o.color === "B/W") {
                result.push("B/W");
            }
        }

        // Double sided (convert YES → label, NO → skip)
        if (o.doubleSided === "Yes") {
            result.push("Double Sided");
        }

        // Binding (YES → Binding, NO → ignore)
        if (o.binding === "Yes") {
            result.push("Binding");
        }

        // Paper thickness (only if exists)
        if (o.paperThickness) result.push(o.paperThickness);

        // Quantity → X format
        if (o.quantity) {
            result.push(`X${o.quantity}`);
        }

        // 📐 PrintType
        if (o.printType) {
            result.push(o.printType);
        }

        // 📐 Quality
        if (o.quality) {
            result.push(o.quality);
        }

        // 📐 Orientation
        if (o.orientation) {
            result.push(o.orientation);
        }

        // 📐 Print Needed By
        if (o.printNeedBy) {
            result.push(o.printNeedBy);
        }

        return result.join(", ");
    };

    return (
        <div className="px-[24px] py-[16px] border-b border-[#e4e5e7] last:border-b-0 hover:bg-[#fafafa] transition-colors">

            {/* Desktop View */}
            <div className="hidden md:grid grid-cols-[1fr_2fr_80px_120px] gap-[16px] items-center">

                {/* File Name */}
                <div className="flex items-center gap-[10px] min-w-0">
                    <div className="w-[32px] h-[32px] rounded-[8px] bg-[#fff0ec] flex items-center justify-center shrink-0">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="w-[16px] h-[16px] text-[#c0392b]"
                        >
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                            <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                            <path d="M10 9H8" />
                            <path d="M16 13H8" />
                            <path d="M16 17H8" />
                        </svg>
                    </div>

                    <span className="text-[13px] text-[#212326] font-semibold truncate">
                        {file.name}
                    </span>
                </div>

                {/* Details */}
                <span className="text-[13px] text-[#717182] font-semibold">
                    {formatOptions(file) || "No print options selected"}
                </span>

                {/* Pages */}
                <span className="text-[13px] text-[#212326] text-center font-semibold">
                    {file.pageCount || 1}
                </span>

                {/* Download */}
                <button
                    onClick={onDownload}
                    className="flex items-center justify-center gap-[6px] px-[12px] py-[7px] rounded-[8px] border border-[#e4e5e7] text-[#212326] text-[12px] font-medium hover:bg-[#f4f5f6] transition-colors mx-auto"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-[14px] h-[14px]"
                    >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" x2="12" y1="15" y2="3" />
                    </svg>
                    Download
                </button>
            </div>

            {/* Mobile View */}
            <div className="md:hidden flex flex-col gap-[8px]">

                <div className="flex items-center gap-[10px]">
                    <div className="w-[32px] h-[32px] rounded-[8px] bg-[#fff0ec] flex items-center justify-center shrink-0">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="w-[16px] h-[16px] text-[#c0392b]"
                        >
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                            <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                            <path d="M10 9H8" />
                            <path d="M16 13H8" />
                            <path d="M16 17H8" />
                        </svg>
                    </div>

                    <span className="text-[13px] text-[#212326] font-medium">
                        {file.name}
                    </span>
                </div>

                <p className="text-[12px] text-[#717182] pl-[42px]">
                    {formatOptions(file) || "No print options selected"}
                </p>

                <button
                    onClick={onDownload}
                    className="flex items-center gap-[6px] ml-[42px] text-[#ff5323] text-[12px] font-medium"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-[14px] h-[14px]"
                    >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" x2="12" y1="15" y2="3" />
                    </svg>
                    Download
                </button>
            </div>
        </div>
    );
};

export default JobFileItem;